<template>
    <FiltersModal
        :title="title"
        :filter-groups="filterGroups"
        :selected-filters="selectedFilters"
        :apply-changes="applyChangesFromBase"
    >
        <DField class="mb-4">
            <div class="font-medium text-lg ml-4 my-2">
                View
            </div>
            <div class="ml-4 flex items-center gap-x-2">
                <DChip
                    v-if="supportedViews.includes(VIEW_MONTH)"
                    :selected="currentViewValue === VIEW_MONTH"
                    left-icon="ph:calendar-dots"
                    data-cy="events-view-month-chip"
                    @click="currentViewValue = VIEW_MONTH"
                >
                    Month
                </DChip>
                <DChip
                    v-if="supportedViews.includes(VIEW_WEEK)"
                    :selected="currentViewValue === VIEW_WEEK"
                    left-icon="ph:rows"
                    data-cy="events-view-week-chip"
                    @click="currentViewValue = VIEW_WEEK"
                >
                    Week
                </DChip>
                <DChip
                    v-if="supportedViews.includes(VIEW_DAY)"
                    :selected="currentViewValue === VIEW_DAY"
                    left-icon="ph:calendar"
                    data-cy="events-view-day-chip"
                    @click="currentViewValue = VIEW_DAY"
                >
                    Day
                </DChip>
            </div>
        </DField>
    </FiltersModal>
</template>
<script setup>
    import {
        DChip, DField
    } from '@digistorm/spark'
    import FiltersModal from '@/components/next-gen/widget-pages/shared/FiltersModal.vue'
    import { useCalendarHelpers } from '@/composables/calendarHelpers'

    const props = defineProps({
        title: String,
        filterGroups: Array,
        selectedFilters: Object,
        currentView: String,
        supportedViews: Array,
        applyChanges: Function,
    })

    const calendarHelpers = useCalendarHelpers()

    const { VIEW_MONTH, VIEW_WEEK, VIEW_DAY } = calendarHelpers

    const currentViewValue = ref(props.currentView)

    const applyChangesFromBase = (filters) => {
        props.applyChanges(
            currentViewValue.value,
            filters,
        )
    }
</script>
